import { combineReducers } from "redux";

import appReducerData from '../reducers'

const rootReducer = combineReducers({
    appData: appReducerData
})

export default rootReducer;